import addDays from 'date-fns/addDays/index.js';

export const parseClickKeyFromStorage = () => {
  const cookie_oven_string = localStorage.getItem('cookie_oven');
  if (!cookie_oven_string) return;

  const cookie_oven = JSON.parse(cookie_oven_string);

  const is_expired = addDays(new Date(cookie_oven.created_at), 2) < new Date();
  if (is_expired) return;

  return cookie_oven.click_key;
};

export const setCookieOvenData = () => {
  const click_key = location.query?.click_key;
  if (click_key) {
    const cookie_oven = {
      click_key,
      created_at: new Date(),
    };
    localStorage.setItem('cookie_oven', JSON.stringify(cookie_oven));
  }
};

export const removeCookieOvenData = () => {
  localStorage.removeItem('cookie_oven');
};
